<template>
    <div class="inline-block overflow-hidden">
      <Transition name="slide-fade" mode="out-in" appear >
        <div v-if="currentItem.length > 0 " :key="currentItem" class="inline-block">
          "{{ currentItem }}"
        </div>
      </Transition>
    </div>
  </template>
  
  <script setup>
  import { ref, computed, onMounted } from 'vue'
  
  const props = defineProps(['items'])
  const index = ref(0)
  const currentItem = ref('')
  const filteredItems = computed(() =>
    (props.items || []).filter(item => item !== 'Food & Beverages')
  )
  const delayBetweenItems = 2200
  const showNextItem = () => {
    currentItem.value = filteredItems.value[index.value]
    index.value = (index.value + 1) % filteredItems.value.length
    setTimeout(showNextItem, delayBetweenItems)
  }
  
  onMounted(() => {
    if (filteredItems.value.length) showNextItem()
  })
  </script>
  
  <style>
  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: all 0.5s ease;
  }
  
  .slide-fade-enter-from {
    transform: translateY(20px);
    opacity: 0;
  }
  
  .slide-fade-enter-to {
    transform: translateY(0);
    opacity: 1;
  }
  
  .slide-fade-leave-from {
    transform: translateY(0);
    opacity: 1;
  }
  
  .slide-fade-leave-to {
    transform: translateY(-20px);
    opacity: 0;
  }
  </style>